export const ru = {
    'accepted-status': 'Допущена к показам',
    'active-status': 'Активна',
    'archived-status': 'В архиве',
    'banner-type-cpm-indoor': 'Внутренняя реклама',
    'banner-type-cpm-indoor-1': 'Реклама в помещениях',
    'banner-type-cpm-outdoor': 'Наружная реклама',
    'banner-type-cpm_audio': 'Аудио',
    'banner-type-cpm_banner': 'Медийный баннер',
    'banner-type-cpm_geoproduct': 'Баннер в Яндекс.Метро',
    'banner-type-cpm_video': 'Видео',
    'banner-type-dynamic': 'Динамическое объявление',
    'banner-type-internal': 'Внутренняя реклама',
    'banner-type-internal-distrib': 'Дистрибуционные объявления',
    'banner-type-internal-free': 'Бесплатные объявления',
    'banner-type-mcbanner': 'Баннер на поиске',
    'banner-type-performance': 'Смарт-баннер',
    'banner-type-text-mobile': 'Текстово-графическое объявление мобильное',
    'draft-status': 'Черновик',
    'ends-with-one-block-error': 'В блоке есть {count} ошибка',
    'group-type-chooser-audio': 'аудио',
    'group-type-chooser-banners': 'баннеры',
    'group-type-chooser-geoproduct': 'баннер в Яндекс.Метро',
    'group-type-chooser-indoor': 'внутренняя реклама',
    'group-type-chooser-indoor-1': 'реклама в помещениях',
    'group-type-chooser-outdoor': 'наружная реклама',
    'group-type-chooser-video': 'видео',
    'group-type-text': 'Текстово-графическое объявление',
    'many-block-error': 'В блоке есть {count} ошибок',
    'moderation-status': 'На модерации',
    'no-status': 'Объявления не созданы',
    'one-block-error': 'В блоке есть ошибка',
    'preaccepted-status': 'Предварительно допущена к показам',
    'previous-version-showing-status-desc': 'Показывается предыдущая версия',
    'processing-status': 'Идет обработка',
    'rejected-on-moderation': 'Не прошла модерацию',
    'rejected-status': 'Отклонена',
    'showing-status': 'Идут показы',
    'showing-status-desc': 'Идут показы',
    'some-block-error': 'В блоке есть {count} ошибки',
    'stopped-status': 'Остановлена'
};
